<template lang="pug">
  .container-settle.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/settle") 结算账户管理
          el-breadcrumb-item 富力钱包
    template(v-if="mchDetail.type === 1")
      c-box
        el-form(:model="source",label-position="right",label-width="150px")
          el-row
            el-col(:span="12")
              el-form-item(label="账户名称：") {{walletInfo.title}}
                el-button(type="primary", @click="editTitleClick", style="margin-left:10px;") 修改账户名称
          el-row
            el-col(:span="12")
              el-form-item(label="安全手机号：") {{tunnelInfo.security_tel | desensitization}}
                el-button(type="primary",@click="editSecPhone",style="margin-left:10px;",v-if="tunnelInfo.security_tel") 修改安全手机
                el-button(type="primary",@click="setSecPhone",style="margin-left:10px;",v-else) 设置安全手机
            el-col(:span="12")
              el-form-item(label="绑定卡号：") {{def_wallet_card.deposit_bank}} {{def_wallet_card.bank_account | desensitization(4,16)}}
          el-row
            el-col(:span="12")
              el-form-item(label="账户余额：") {{ tunnelInfo.balance || 0 | toYuan }}
          el-row
            el-col(:span="12")
              el-form-item(label="可提现余额：") {{ tunnelInfo.balance-tunnelInfo.freezen_amount || 0 | toYuan }}
            el-col(:span="12")
              el-form-item(label="冻结金额：") {{ walletInfo.freeze_amount || 0 | toYuan }}
          el-row
            el-col(:span="24")
              el-form-item(label="按日账户余额查询：")
                el-date-picker(v-model="balance_search_date", type="date", placeholder="选择日期",@change="getBalanceForDay",:picker-options="dateOptions")
                span(v-if='balance_txt_day',class="balance_txt_day") {{balance_txt_day}}当日的余额为 <b>{{balance_txt || 0 | toYuan}}</b>
          el-row
            el-col(:span="24")
              el-form-item(label="按日期查询收入：")
                el-date-picker(v-model="balance_search_scope", type="daterange",start-placeholder="开始日期",end-placeholder="结束日期",@change="getBalanceForScope",size="small",:picker-options="scopeOptions")
                span(v-if='balance_txt_scope',class="balance_txt_day") {{balance_txt_scope}}
          el-row
            el-button(round,@click="withdraw") 提现
            span.txt-tip Tip:当天充值金额在下个工作日可提现
      c-box
        c-header-small
          template(slot="left") 
            div 余额明细
        c-box.container-filters
          el-form(:model="filters",label-position="right",label-width="100px")
            el-row(:gutter="10")
              el-col(:span="8")
                el-form-item(label="日期")
                  el-date-picker(v-model="order_date", type="daterange", placeholder="选择日期范围")
              el-col(:span="6")
                el-form-item(label="交易类型")
                  el-select(v-model="filters.trade_type")
                    el-option(:value="null", label="所有")
                    el-option(v-for="a in [1,2,3,4,5,6,8]", :key="a", :value="a", :label="a | pay_type_select")
              el-col(:span="6")
                el-form-item(label="状态")
                  el-select(v-model="filters.status")
                    el-option(:value="null", label="所有")
                    el-option(v-for="a in [2,3,4,5]", :key="a", :value="a", :label="a | detail_status")
            el-row(:gutter="10")
              el-col(:span="8")
                el-form-item(label="")
                  el-button(@click="setFilterExport",type="primary") 导出
                  el-button(@click="setFilter",type="primary") 搜索
                  el-button(@click="clearFilter", v-show="hasFilter") 清除搜索条件
        el-table(:data="list", fit, v-loading="listLoading")
          el-table-column(property="create_time", label="时间", min-width="125", show-tooltip-when-overflow)
          el-table-column(property="tunnel_order_no", label="通联渠道单号", min-width="220", show-tooltip-when-overflow)
          el-table-column(property="order_no", label="订单号", min-width="220", show-tooltip-when-overflow)
          el-table-column(label="关联支付单号", min-width="220", show-tooltip-when-overflow, v-slot="{ row }") {{ row.type === 5 ? row.biz_no : "-" }}
          el-table-column(label="类型", min-width="125", show-tooltip-when-overflow, v-slot="{ row }") {{ row | pay_type(settle_account) }}
          el-table-column(label="状态", min-width="125", show-tooltip-when-overflow, v-slot="{ row }") {{ row.status | detail_status }}
          el-table-column(label="金额", min-width="125", show-tooltip-when-overflow, v-slot="{ row }" ) {{ row | symbol(settle_account)}} {{row.amount |toYuan(true)}}
          el-table-column(label="说明", min-width="125", show-tooltip-when-overflow, v-slot="{ row }") {{ row.note }}
          el-table-column(label="操作", width="175", v-slot="{ row }")
            .row-toolbox
              el-button(type="primary", size="small", @click="showDetail(row)") 查看详情
        .container-pagination
          el-pagination(layout="sizes, prev, pager, next, total",
            :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
            @size-change="changeListSize", @current-change="getList")
    template(v-else)
      .align-center
        qriously(:value="wallet_url", :size="240", :padding="20" v-if="wallet_url")
        h4 扫描二维码访问您的富力钱包
    
    el-dialog(title="余额明细", :visible.sync="dialog",width="35%")
      el-form(label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="明细单号", required)
          span {{orderDetail.tunnel_order_no}}
        el-form-item(label="操作类型", required)
          span {{ orderDetail | pay_type(settle_account) }}
        el-form-item(label="操作时间", required)
          span {{ orderDetail.create_time }}
        el-form-item(label="状态", required)
          span {{ orderDetail.status | detail_status }}
        el-form-item(label="交易金额", required)
          span {{orderDetail | symbol(settle_account)}}{{orderDetail.amount | toYuan(true)}} 元
        el-form-item(label="关联交易号", required)
          span {{orderDetail.order_no}}
        el-form-item(label="备注", required)
          span {{orderDetail.note}}  

    el-dialog(title="修改账户名称", :visible.sync="editTitle.show",width="35%")
      el-form(label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="账户名称", required)
          el-input(v-model='editTitle.source.title',type="text")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveTitleSubmit()") 保存
        el-button(@click="hideEditTitle()") 取消
</template>

<script>
import dayjs from "dayjs";
import filters from "@/gadgets/filters";
export default {
  data() {
    return {
      source: {
        mobile: this.$store.state.mchDetail.resp_per_telephone_no,
        settle_account: this.$route.params.settle_account
      },
      settle_account: Number(this.$route.params.settle_account),
      walletInfo: {},
      tunnelInfo: {},
      filters: {
        status: null,
        trade_type: null,
        settle_id: this.$route.params.settle_id
      },
      orderDetail: {},
      dialog: false,
      list: [],
      verify_locked: false,
      countdown: -1,
      listLoading: false,
      hasFilter: false,
      page: 1,
      size: 10,
      status: 0,
      list: [],
      total: 0,
      wallet_url: null,
      order_date: [],
      editTitle: {
        show: false,
        source: {
          title: ""
        }
      },
      def_wallet_card: {},
      balance_search_date: "",
      balance_txt: "",
      balance_txt_day: "",
      balance_txt_scope: "",
      balance_search_scope: [],
      dateOptions: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() > Date.now();
        }
      },
      scopeOptions: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() > Date.now() - 1000 * 3600 * 24 * 1;
        }
      }
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    mchDetail() {
      return this.$store.getters.mchDetail;
    }
  },
  methods: {
    // 获取范围的余额
    getBalanceForScope() {
      if (!this.balance_search_scope || this.balance_search_scope.length < 2) {
        // this.$message.error(`请选择日期范围`);
        this.balance_txt_scope = "";
        return;
      }
      const start_date = dayjs(this.balance_search_scope[0]).format(
        "YYYY-MM-DD"
      );
      const end_date = dayjs(this.balance_search_scope[1]).format("YYYY-MM-DD");
      const params = {
        wallet_id: this.$route.params.settle_account,
        start_date,
        end_date
      };

      this.$store
        .dispatch("QUERY_WALLET_INCOME", params)
        .then(res => {
          // debugger
          const income = res ? filters.toYuan(res) : 0;
          this.balance_txt_scope = `${start_date}-${end_date}的收入： ${income}`;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取${this.balance_txt_scope}失败。${code}：${msg}`
          });
        });
    },
    // 获取某天的余额
    getBalanceForDay() {
      if (!this.balance_search_date) {
        this.balance_txt_day = "";
        return;
      }
      const params = {
        wallet_id: this.$route.params.settle_account,
        start_date: dayjs(this.balance_search_date).format("YYYY-MM-DD"),
        end_date: dayjs(this.balance_search_date)
          .add(1, "day")
          .format("YYYY-MM-DD")
      };

      this.$store
        .dispatch("QUERY_WALLET_BALANCE_LOG", params)
        .then(res => {
          this.balance_txt_day = dayjs(this.balance_search_date).format(
            "YYYY-MM-DD"
          );
          if (res && res.length > 0) {
            this.balance_txt = res[0].balance_amount;
          } else {
            this.balance_txt = 0;
          }
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取${this.balance_txt_day}的余额失败。${code}：${msg}`
          });
        });
    },
    // 修改安全手机
    editTitleClick() {
      this.editTitle = {
        show: true,
        source: {
          title: this.walletInfo.title,
          wallet_id: this.$route.params.settle_account
        }
      };
    },
    hideEditTitle() {
      this.editTitle = {
        show: false,
        source: {
          title: ""
        }
      };
    },
    saveTitleSubmit() {
      if (!this.editTitle.source.title) {
        this.$message({
          type: "warning",
          message: `请输入账户名称。`
        });
      }

      const params = Object.assign({}, this.editTitle.source);

      this.$store
        .dispatch("MODIFY_WALLET", params)
        .then(() => {
          this.getWalletInfo();
          //   this.getTunnelInfo();
          this.hideEditTitle();
          this.$message({
            type: "success",
            message: "修改账户名称成功。"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `修改账户名称定失败。${code}：${msg}`
          });
        });
    },

    // 修改安全手机
    editSecPhone() {
      this.$router.push(
        `/wallet/reg-wallet-5/${this.$route.params.settle_account}/${
          this.$route.params.settle_id
        }`
      );
    },
    // 设置安全手机
    setSecPhone() {
      this.$router.push(
        `/wallet/reg-wallet-6/${this.$route.params.settle_account}/${
          this.$route.params.settle_id
        }`
      );
    },
    // 提现
    withdraw() {
      this.$router.push(
        `/wallet/withdraw/${this.$route.params.settle_account}/${
          this.$route.params.settle_id
        }`
      );
    },
    showDetail(data) {
      this.dialog = true;
      this.orderDetail = data;
    },
    // 获取二维码登陆页面
    getWalletURL() {
      this.$store
        .dispatch("GET_WALLET_URL")
        .then(({ wallet_base_url }) => {
          this.wallet_url = wallet_base_url;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取富力钱包页面地址失败。${code}：${msg}`
          });
        });
    },
    // getTunnelInfo() {
    //   // 需要先查一下当前的钱包渠道状态
    //   this.$store
    //     .dispatch("GET_WALLET_CHANNEL_INFO", this.$route.params.settle_account)
    //     .then(res => {
    //       this.tunnelInfo = res;
    //     })
    //     .catch(({ code, msg }) => {
    //       this.$message({
    //         type: "error",
    //         message: `获取钱包失败。${code}：${msg}`
    //       });
    //     });
    // },
    getWalletInfo() {
      //   console.log("钱包参数", this.$route.params.settle_account);
      // 当前的钱包状态
      this.$store
        .dispatch("GET_WALLET_INFO", {
          settle_id: this.$route.params.settle_id
        })
        .then(res => {
          if (res) {
            this.walletInfo = res.wallet;
            this.tunnelInfo = res.wallet_tunnel;
            this.def_wallet_card = res.def_wallet_card;
          }
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取钱包失败。${code}：${msg}`
          });
        });
    },
    changeStatus() {},
    clearFilter() {
      this.filters = {
        status: null,
        trade_type: null,
        settle_id: this.$route.params.settle_id
      };
      this.order_date = [];
      this.hasFilter = false;
      this.getList(1);
    },
    changeListSize(size = 20) {
      this.size = size;
      this.getList(1);
    },
    setFilter() {
      // console.log(this.order_date)
      if (!this.order_date) {
        this.order_date = [];
      }
      if (
        this.filters.status ||
        this.filters.trade_type ||
        this.order_date.length > 0
      ) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }
      this.getList(1);
    },
    setFilterExport() {
      if (
        this.filters.status ||
        this.filters.trade_type ||
        this.order_date.length > 0
      ) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }
      this.exportData(1);
    },
    exportData() {
      const params = Object.assign({}, this.filters, {
        begin_date:
          Array.isArray(this.order_date) &&
          typeof this.order_date[0] !== "undefined"
            ? this.$dateFormatter(this.order_date[0])
            : null,
        end_date:
          Array.isArray(this.order_date) &&
          typeof this.order_date[1] !== "undefined"
            ? this.$dateFormatter(this.order_date[1])
            : null
      });
      if (!params.begin_date || !params.end_date) {
        this.$message({
          type: "error",
          message: `导出必须选择时间段`
        });
        return;
      }
      const _filters = Object.assign({}, params);
      this.$store
        .dispatch("EXPORT_ORDER_DETAIL", _filters)
        .then(data => {
          this.$message({
            type: "success",
            message: `导出成功，请在右上角中的“报表下载列表”中查看。`
          });
          this.getList();
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    refresh() {
      this.getList(this.page);
    },
    getList(page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }
      const params = Object.assign({}, this.filters, {
        from_time:
          Array.isArray(this.order_date) &&
          typeof this.order_date[0] !== "undefined"
            ? this.$dateFormatter(this.order_date[0])
            : null,
        to_time:
          Array.isArray(this.order_date) &&
          typeof this.order_date[1] !== "undefined"
            ? this.$dateFormatter(this.order_date[1])
            : null
      });
      const _filters = Object.assign({}, params);
      this.$store
        .dispatch(
          "ORDER_LIST",
          Object.assign(
            {
              offset: this.size * (this.page - 1),
              limit: this.size,
              stat: 1
            },
            _filters
          )
        )
        .then(data => {
          this.list = data.list;
          this.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  },
  mounted() {
    this.getWalletInfo();
    // this.getTunnelInfo();
    if (this.mchDetail.type === 1) {
      this.getList();
    }

    this.getWalletURL();
  }
};
</script>
<style lang="less" scoped>
.balance_txt_day {
  margin-left: 20px;
}
</style>
